import { isClientFeatureEnabled } from '@wh/feature-toggle-detector';
import Translator from '../Translator';
import { get } from '../../../utils';

export const getLocale = () => Translator.getLocale();

const getConfig = () => get(window, 'whStatic.config.gamingWidget', {
    enabled: false,
    locales: ['en-gb'],
    featureQuery: 'gamingWidgetEnabled',
});

const isProperLocale = () => {
    const { locales } = getConfig();
    return locales.includes(getLocale());
};

const isFeatureEnabled = () => {
    const { enabled, featureQuery } = getConfig();
    return (enabled || isClientFeatureEnabled(featureQuery, 'public'));
};

export const isGamingWidgetActive = () => isProperLocale() && isFeatureEnabled();
